// extracted by mini-css-extract-plugin
module.exports = {"back-to-top":"c5","backToTop":"c5"};